export interface SalesManifestSearch {
  search: string;
}
